import axiosInstance from "./axiosInstance";

const crearReservacion = async (data) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/crearReservacion`,
    data,
    { withCredentials: true }
  );
};

export default crearReservacion;

export const crearReservacionExterna = async (data) => {
  return await axiosInstance.post(
    `${process.env.REACT_APP_BASE_URL}/crearReservacionExterna`,
    data
  );
};
